<template>
  <div class="container">
    <div class="row">
      <div class="col-6 offset-3" v-if="registrationEnabled">
        <div class="row" v-if="registerSuccessful">
          <div class="col-10 offset-1">
            <p>Successfully registered user.</p>
            <p>If you are not automatically redirected to login page,
              <router-link to="/auth/login">click here</router-link>
            </p>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-10 offset-1">
            <h1>Signup</h1>
            <form method="#" action="#" v-on:submit.prevent="handleRegister">
              <div class="alert alert-danger text-center" v-show="hasErrors" v-text="errorMessage"></div>
              <div class="form-group">
                <label>Username</label>
                <input class="form-control" name="username" type="text" v-model="model.user.username"
                    placeholder="Username"/>
              </div>
              <div class="form-group">
                <label>Email</label>
                <input class="form-control" name="email" type="text" v-model="model.user.email"
                  placeholder="Email"/>
              </div>
              <div class="form-group">
                <label>Password</label>
                <input class="form-control" name="password" type="password" v-model="model.user.password"
                    placeholder="Password"/>
              </div>
              <div class="form-group">
                <label>Password Confirmation</label>
                <input class="form-control" name="confirmPassword" type="password"
                  v-model="model.user.confirmPassword" placeholder="Password Confirmation"/>
              </div>
              <div class="form-group">
                <label>First Name</label>
                <input class="form-control" name="firstName" type="text" v-model="model.user.firstName"
                  placeholder="First Name"/>
              </div>
              <div class="form-group">
                <label>Last Name</label>
                <input class="form-control" name="lastName" type="text" v-model="model.user.lastName"
                  placeholder="Last Name"/>
              </div>
              <button type="submit" class="btn btn-block btn-info btn-wd">Register</button>
            </form>
          </div>
        </div>
      </div>
      <div class="col-6 offset-3" v-else>
        <h1>User registration is disabled</h1>
        <p>The user registration system has been disabled by the administrator.</p>
        <p>You can only login into the application by
          <router-link to="/auth/login">clicking here</router-link>.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    registrationEnabled() {
      const config = this.$beast.config.userRegistration;
      return config === null || config === undefined || !!config;
    }
  },
  data() {
    return {
      model: {
        user: {
          username: "",
          email: "",
          password: "",
          confirmPassword: "",
          firstName: "",
          lastName: ""
        }
      },
      hasErrors: false,
      errorMessage: "",
      registerSuccessful: false
    };
  },
  methods: {
    async handleRegister() {
      this.hasErrors = false;
      try {
        const response = await this.axios.post("/auth/register", this.model);
        if (response.data.status !== "ok") {
          throw new Error(`Unhandled response from server: ${response.data.status}`);
        }
        this.registerSuccessful = true;
        setTimeout(() => {
          this.$router.push("/auth/login");
        }, 2000);
      } catch (error) {
        this.hasErrors = true;
        this.errorMessage = error;
        if (error.response) {
          this.errorMessage = error.response.data.message;
        }
      }
    }
  },
  mounted() {
    this.setTitle("Sign up");
  }
};
</script>
<style scoped>
  .btn-wd{
    margin-top: 10px;
    margin-bottom: 35px;
  }
</style>
